/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';


import * as ContentBlock from 'src/components/ContentBlock';
import * as JssForm from 'src/components/JssForm';
import * as customFieldFactory from 'src/components/customFieldFactory';
import * as customFieldTypes from 'src/components/customFieldTypes';
import * as BasketEmailCartForm from 'src/components/CustomForms/BasketEmailCartForm';
import * as Checkbox from 'src/components/FieldTemplates/Checkbox';
import * as CheckboxList from 'src/components/FieldTemplates/CheckboxList';
import * as CountrySelector from 'src/components/FieldTemplates/CountrySelector';
import * as DropdownList from 'src/components/FieldTemplates/DropdownList';
import * as Email from 'src/components/FieldTemplates/Email';
import * as EmailWithConfirmation from 'src/components/FieldTemplates/EmailWithConfirmation';
import * as FileUpload from 'src/components/FieldTemplates/FileUpload';
import * as HiddenReferrer from 'src/components/FieldTemplates/HiddenReferrer';
import * as HiddenText from 'src/components/FieldTemplates/HiddenText';
import * as HintTextbox from 'src/components/FieldTemplates/HintTextbox';
import * as MultipleLineText from 'src/components/FieldTemplates/MultipleLineText';
import * as NumberInput from 'src/components/FieldTemplates/NumberInput';
import * as RadioButtonList from 'src/components/FieldTemplates/RadioButtonList';
import * as RichText from 'src/components/FieldTemplates/RichText';
import * as SubmitButton from 'src/components/FieldTemplates/SubmitButton';
import * as Telephone from 'src/components/FieldTemplates/Telephone';
import * as TelephoneWithDialCode from 'src/components/FieldTemplates/TelephoneWithDialCode';
import * as UserDevicesSelector from 'src/components/FieldTemplates/UserDevicesSelector';
import * as ChineseRecaptchaStubInput from 'src/components/FieldTemplates/Recaptcha/ChineseRecaptchaStubInput';
import * as GoogleRecaptchaV3 from 'src/components/FieldTemplates/Recaptcha/GoogleRecaptchaV3';
import * as GoogleRecaptchaV3Input from 'src/components/FieldTemplates/Recaptcha/GoogleRecaptchaV3Input';
import * as DefaultForm from 'src/components/FormVariants/DefaultForm';
import * as FormBody from 'src/components/FormVariants/FormBody';
import * as FormComponent from 'src/components/FormVariants/FormComponent';
import * as TspForm from 'src/components/FormVariants/TspForm';
import * as types from 'src/components/FormVariants/types';
import * as FieldValidationError from 'src/components/Shared/FieldValidationError';
import * as FieldWrapper from 'src/components/Shared/FieldWrapper';
import * as FormValidationError from 'src/components/Shared/FormValidationError';
import * as JabraFileUpload from 'src/components/Shared/JabraFileUpload';
import * as JabraInput from 'src/components/Shared/JabraInput';
import * as JabraLabel from 'src/components/Shared/JabraLabel';
import * as JabraLegend from 'src/components/Shared/JabraLegend';
import * as JabraSelect from 'src/components/Shared/JabraSelect';
import * as JabraTextarea from 'src/components/Shared/JabraTextarea';
import * as Spinner from 'src/components/Shared/Spinner';
import * as TspCheckbox from 'src/components/Tsp/TspCheckbox';
import * as TspCheckboxList from 'src/components/Tsp/TspCheckboxList';
import * as TspDropdownList from 'src/components/Tsp/TspDropdownList';
import * as TspEmailWithConfirmation from 'src/components/Tsp/TspEmailWithConfirmation';
import * as TspFieldWrapper from 'src/components/Tsp/TspFieldWrapper';
import * as TspFileUpload from 'src/components/Tsp/TspFileUpload';
import * as TspLabel from 'src/components/Tsp/TspLabel';
import * as TspRadioButtonList from 'src/components/Tsp/TspRadioButtonList';
import * as TspRichText from 'src/components/Tsp/TspRichText';
import * as TspSelect from 'src/components/Tsp/TspSelect';
import * as TspSubmitButton from 'src/components/Tsp/TspSubmitButton';
import * as TspTelephoneWithDialCode from 'src/components/Tsp/TspTelephoneWithDialCode';
import * as TspText from 'src/components/Tsp/TspText';
import * as tspFieldFactory from 'src/components/Tsp/tspFieldFactory';
import * as tspNavigationState from 'src/components/Tsp/tspNavigationState';

export const components = new Map();

components.set('ContentBlock', ContentBlock);
components.set('JssForm', JssForm);
components.set('customFieldFactory', customFieldFactory);
components.set('customFieldTypes', customFieldTypes);
components.set('BasketEmailCartForm', BasketEmailCartForm);
components.set('Checkbox', Checkbox);
components.set('CheckboxList', CheckboxList);
components.set('CountrySelector', CountrySelector);
components.set('DropdownList', DropdownList);
components.set('Email', Email);
components.set('EmailWithConfirmation', EmailWithConfirmation);
components.set('FileUpload', FileUpload);
components.set('HiddenReferrer', HiddenReferrer);
components.set('HiddenText', HiddenText);
components.set('HintTextbox', HintTextbox);
components.set('MultipleLineText', MultipleLineText);
components.set('NumberInput', NumberInput);
components.set('RadioButtonList', RadioButtonList);
components.set('RichText', RichText);
components.set('SubmitButton', SubmitButton);
components.set('Telephone', Telephone);
components.set('TelephoneWithDialCode', TelephoneWithDialCode);
components.set('UserDevicesSelector', UserDevicesSelector);
components.set('ChineseRecaptchaStubInput', ChineseRecaptchaStubInput);
components.set('GoogleRecaptchaV3', GoogleRecaptchaV3);
components.set('GoogleRecaptchaV3Input', GoogleRecaptchaV3Input);
components.set('DefaultForm', DefaultForm);
components.set('FormBody', FormBody);
components.set('FormComponent', FormComponent);
components.set('TspForm', TspForm);
components.set('types', types);
components.set('FieldValidationError', FieldValidationError);
components.set('FieldWrapper', FieldWrapper);
components.set('FormValidationError', FormValidationError);
components.set('JabraFileUpload', JabraFileUpload);
components.set('JabraInput', JabraInput);
components.set('JabraLabel', JabraLabel);
components.set('JabraLegend', JabraLegend);
components.set('JabraSelect', JabraSelect);
components.set('JabraTextarea', JabraTextarea);
components.set('Spinner', Spinner);
components.set('TspCheckbox', TspCheckbox);
components.set('TspCheckboxList', TspCheckboxList);
components.set('TspDropdownList', TspDropdownList);
components.set('TspEmailWithConfirmation', TspEmailWithConfirmation);
components.set('TspFieldWrapper', TspFieldWrapper);
components.set('TspFileUpload', TspFileUpload);
components.set('TspLabel', TspLabel);
components.set('TspRadioButtonList', TspRadioButtonList);
components.set('TspRichText', TspRichText);
components.set('TspSelect', TspSelect);
components.set('TspSubmitButton', TspSubmitButton);
components.set('TspTelephoneWithDialCode', TspTelephoneWithDialCode);
components.set('TspText', TspText);
components.set('tspFieldFactory', tspFieldFactory);
components.set('tspNavigationState', tspNavigationState);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
